module.exports = __webpack_public_path__ + "img/阿尔法与“链上海南”战略合作.c5e3330f.png";